import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { useAuth } from "../auth";
import { Lock, User } from "lucide-react";

const Login = () => {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(form.username, form.password);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-neutral-50 flex items-center justify-center px-4 pt-24 pb-16">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl border border-neutral-100 p-8 shadow-[0_20px_50px_rgba(0,0,0,0.05)]">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md flex items-center justify-center bg-[#C9A24B]">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <div className="font-black text-xl text-[#1a1a1a]">Yönetici Girişi</div>
            <div className="text-sm text-neutral-500">Koptur Grup CMS</div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-sm text-neutral-700">Kullanıcı Adı</Label>
            <div className="mt-1.5 relative">
              <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
              <Input
                className="pl-9 h-11"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                placeholder="admin"
              />
            </div>
          </div>
          <div>
            <Label className="text-sm text-neutral-700">Şifre</Label>
            <Input
              type="password"
              className="mt-1.5 h-11"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
            />
          </div>
          {err && <div className="text-sm text-red-600 bg-red-50 rounded-md px-3 py-2">{err}</div>}
          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1a1a1a] hover:bg-[#C9A24B] text-white h-11 rounded-full font-semibold"
          >
            {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
          </Button>
        </div>
      </form>
    </main>
  );
};

export default Login;
